<template>
  <bk-page 
        class="view-signInSuccess"
		pageType="navPage" 
		:navBarInfo="navBarInfo"
	>
    <bk-view class="view-signInContent" >
        <bk-view class="view-top">
            <bk-image src="https://static-global.boka.vc/mase/def/Def_Bg_CheckIn_SignIn.png"></bk-image>
            <bk-image :src="info?.member?.avatar"></bk-image>
            <bk-view class="view-welcome"><bk-lang code="signIn_welcome"></bk-lang></bk-view>
            <bk-view class="view-name">{{info?.member?.name || '-'}}</bk-view>
        </bk-view>
        <bk-view class="view-awardInfo"  v-if="info?.status == 1">
            <bk-image src='https://static-global.boka.vc/mase/def/Def_Bg_CheckIn_Gift.png'></bk-image>
            <bk-image src='https://static-global.boka.vc/mase/def/Def_Bg_CheckIn_Award.png'></bk-image>
            <bk-view class="view-num">{{info?.currentBatchCheckInNum || 0}}</bk-view>
            <bk-view><bk-lang code="signIn_visits"></bk-lang></bk-view>
            <bk-view class="view-progressNar">
                <bk-view v-for="item in (Number(info?.rewardsNum)||1)" :key="item" :class="['view-item', info.currentBatchCheckInNum >= item ? 'select' : '']"></bk-view>
            </bk-view>
            <bk-view class="view-explain">
                {{explainText}}
            </bk-view>
        </bk-view>
        <bk-view class="view-cumulativeVisits">
            <bk-lang code="signIn_cumulativeVisits"></bk-lang>
            <span class="view-total"> {{info?.totalCheckInNum || 0}} </span>
            <bk-lang code="signIn_cumulativeVisitsUnit"></bk-lang>
        </bk-view>

        <bk-view class="view-goBack" @click="close">
            <bk-icon class="view-icon" icon="icon-youjiantou" />
            <bk-lang code="signIn_goBack"></bk-lang>
            {{countDown}}
            <bk-lang code="signIn_unit"></bk-lang>
        </bk-view>
    </bk-view>
  </bk-page>
</template>

<script>

	export default {
		name: 'signup',
		components: {
		},
        props:{
            info: Object
		},
		data () {
			return {
				navBarInfo: {
					backFlag: false,
					langCode_title: '',
					titleAlign: 'left',
				},
				bkLoad: false,
                explainText: '',
                countDown: 5,
                timer: null,

				
			};
		},
		methods: {
            close () {
                clearInterval(this.timer);
                this.timer = null;
                this.$emit('close')
                this.$emit('clear')
            }
		},
		created () {
            
		},
		mounted () {
            clearInterval(this.timer);
			this.timer = null;
            this.timer = setInterval(() => {
				if (this.countDown === 0) {
					clearInterval(this.timer);
					this.timer = null;
                    this.close()
				} else {
					this.countDown= this.countDown - 1;
				}
			}, 1000);
            
            this.$nextTick(() => {
                this.explainText = this.$bk_getTextWithLangCode('signIn_explain').replace('#val#', this.info?.rewardsNum || 0);
            })

		}
	};
</script>

<style lang="less" scoped>
.view-signInSuccess.bk-page.navPage {
    padding-top: 0;
    .view-signInContent {
        text-align: center;
        > .view-top {
            background: linear-gradient( 180deg, #E3EDFF 0%, #FFFFFF 100%);
            height: 228px;
            margin-bottom: 10px;
            position: relative;
            > .bk-image:nth-child(1) {
                position: absolute;
                left: 0;

            }
            > .bk-image:nth-child(2) {
                margin: 64px 0 24px;

                background: red;
                width: 72px;
                height: 72px;
                border-radius: 50%;
            }
            > .view-welcome {
                color: #666;
                margin-bottom: 6px;
            }
            > .view-name {
                font-size: 16px;
                font-weight: 600;
            }
        }
        > .view-awardInfo {
            margin: 0 24px;
            padding: 16px;
            background: #f2f5fe;
            height: 144px;
            position: relative;
            > .bk-image:nth-child(1) {
                position: absolute;
                left: 0;
                top: 0;
            }
            > .bk-image:nth-child(2) {
                position: absolute;
                right: 16px;
                top: 47px;
                width: 32px;
                height: 38px;
            }
            > .view-num {
                font-size: 28px;
                color: #2E56F2;
                font-weight: 600;
                line-height: 40px;
            }
            > .view-progressNar {
                margin-top: 12px;
                display: flex;
                > .view-item {
                    flex: 1;
                    border: 1px solid #f2f5fe;
                    height: 8px;
                    background: #dee5fd;
                    &:nth-child(1) {
                        border-radius: 6px 0 0 6px;
                    }
                    &:nth-last-child(1) {
                        border-radius: 0 6px 6px 0;
                    }
                    &.select {
                        background: #2E56F2;
                    }
                }
            }
            > .view-explain {
                margin-top: 12px;
            }
        }
        > .view-cumulativeVisits {
            margin: 32px 0 54px 0;
            > .bk-lang {
                vertical-align: text-bottom;
            }
            > .view-total {
                font-size: 24px;
                font-weight: 600;
                margin: 0 4px;
            }
        }
        > .view-goBack {
            color: #2E56F2;
            display: inline-block;
            border-bottom: 1px solid #2E56F2;
            position: relative;
            > .view-icon{
                position: absolute;
                left: -15px;
                top: -2px;
                transform: rotate(180deg);
                display: inline-block;
                margin-bottom: 2px;
            }
        }
    }
}
</style>